import React from "react";
import { Modal, Button } from "react-bootstrap";

interface FilePreviewProps {
  show: boolean;
  fileUrl: string | null;
  fileName?: string;
  onClose: () => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  show,
  fileUrl,
  fileName = "File Preview",
  onClose,
}) => {
  if (!fileUrl) return null;

  const extension = fileUrl.split(".").pop()?.toLowerCase();

  const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(
    extension || ""
  );
  const isPdf = extension === "pdf";

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{fileName}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {/* IMAGE PREVIEW */}
        {isImage && (
          <img
            src={fileUrl}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
          />
        )}

        {/* PDF PREVIEW */}
        {isPdf && (
          <iframe
            src={fileUrl}
            title="PDF Preview"
            style={{
              width: "100%",
              height: "70vh",
              border: "none",
            }}
          />
        )}

        {/* OTHER FILE TYPES */}
        {!isImage && !isPdf && (
          <div className="py-4">
            <p className="text-muted">
              Preview not available for this file type.
            </p>
            <p>
              <strong>{fileName}</strong>
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-end gap-2">
        <a
          href={fileUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-primary btn-sm"
        >
          Download
        </a>
        <Button variant="secondary" size="sm" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FilePreview;
